import { render } from "./AgentePickJunta.vue?vue&type=template&id=75d97970"
import script from "./AgentePickJunta.vue?vue&type=script&lang=ts"
export * from "./AgentePickJunta.vue?vue&type=script&lang=ts"
script.render = render

export default script